/* src/app/modules/shared/components/header-column/header-column-variant-secondary-price/header-column-variant-secondary-price.component.scss */
app-header-column-variant-secondary-price {
  display: contents;
}
/*# sourceMappingURL=header-column-variant-secondary-price.component.css.map */
